import axios from 'axios';

const BASE = process.env.REACT_APP_API_URL || '/api';

export const api = {
  register:    ()           => axios.post(`${BASE}/users`),
  getProfile:  (userId)     => axios.get(`${BASE}/users/${userId}`),
  checkin:     (userId)     => axios.post(`${BASE}/users/${userId}/checkin`),
  relapse:     (userId)     => axios.post(`${BASE}/users/${userId}/relapse`),
  leaderboard: ()           => axios.get(`${BASE}/users/leaderboard`),
  dailyFact:   (userId)     => axios.get(`${BASE}/users/${userId}/daily-fact`),
  surpriseFact: (userId) => axios.post(`${BASE}/users/${userId}/surprise-fact`),
  weeklyReport:(userId)     => axios.get(`${BASE}/users/${userId}/weekly-report`),

  chat: (userId, message)   => axios.post(`${BASE}/chat`, { userId, message }),

  generateMission: (userId) => axios.post(`${BASE}/missions/${userId}/generate`),
  getMissions:     (userId) => axios.get(`${BASE}/missions/${userId}`),
  completeMission: (missionId, userId) =>
    axios.post(`${BASE}/missions/${missionId}/complete?userId=${userId}`),

  generateQuest: (userId)   => axios.post(`${BASE}/quests/${userId}/generate`),
  getQuests:     (userId)   => axios.get(`${BASE}/quests/${userId}`),
  verifyQuest:   (data)     => axios.post(`${BASE}/quests/verify`, data),

  createChallenge: (challengerId) => axios.post(`${BASE}/challenges`, { challengerId }),
  joinChallenge: (code, opponentId) =>
    axios.post(`${BASE}/challenges/join/${code}`, { opponentId }),
  getUserChallenges: (userId) => axios.get(`${BASE}/challenges/${userId}`),
};
